import { MainTemplate } from "@/components/templates";
import Router from "next/router";

export const RedirectPrivacyPage = () => {
  Router.push("https://corp.moneyforward.com/privacy/");
  return <MainTemplate></MainTemplate>;
};
